import { IState } from "../..";
import { createSlice } from "@reduxjs/toolkit";
import { AppThunk } from "../../../app/store";
import { AccessorialReviewTerminalPerformanceState } from "../ShipmentReconciliationState";
import ShipmentReconciliationService from "../../../app/data/shipment-reconciliation/shipmentReconciliationService";
import { AccessorialReviewTerminalPerformanceRequest } from "../../../app/data/shipment-reconciliation/models";

const initialState: AccessorialReviewTerminalPerformanceState = {
  loading: false,
  loadingFailed: false,
  loaded: false,
  results: []
};

const shipmentReconciliationService = ShipmentReconciliationService.getInstance();

export const accessorialReviewTerminalPerformanceSlice = createSlice({
  name: "accessorialReviewTerminalPerformanceSlice",
  initialState,
  reducers: {
    resetGetAccessorialReviewTerminalPerformanceState: (state) => initialState,
    accessorialReviewTerminalPerformanceLoadingStarted: (state) => {
      state.loading = true;
      state.loadingFailed = false;
      state.loaded = false;
    },
    accessorialReviewTerminalPerformanceSucceed: (state, { payload }) => {
      state.loaded = true;
      state.loading = false;
      state.loadingFailed = false;
      state.results = (payload && payload.performance) ? payload.performance : [];
    },
    accessorialReviewTerminalPerformanceLoadingFailed: (state, { payload }) => {
      state.loading = false;
      state.loadingFailed = true;
    }
  },
});

export const {
  resetGetAccessorialReviewTerminalPerformanceState,
  accessorialReviewTerminalPerformanceLoadingStarted,
  accessorialReviewTerminalPerformanceSucceed,
  accessorialReviewTerminalPerformanceLoadingFailed,
} = accessorialReviewTerminalPerformanceSlice.actions;

export const accessorialReviewTerminalPerformanceSelector = (state: IState) => state.accessorialReviewTerminalPerformance;

export const getAccessorialReviewTerminalPerformance = (
  requestData: AccessorialReviewTerminalPerformanceRequest,
  onError?: (error: string) => void
): AppThunk => async (dispatch) => {
  dispatch(accessorialReviewTerminalPerformanceLoadingStarted());
  const response = await shipmentReconciliationService.getAccessorialReviewTerminalPerformance(requestData);
  if (response.ok() && response.data) {
    dispatch(accessorialReviewTerminalPerformanceSucceed(response.data));
  } else {
    let error = "Internal Server Error, re-try the action or contact support";
    if (response && response.data && response.data.message) error = JSON.stringify(response.data.message);
    dispatch(accessorialReviewTerminalPerformanceLoadingFailed(error));
    onError && onError(error)
  }
};

const accessorialReviewTerminalPerformanceReducer = accessorialReviewTerminalPerformanceSlice.reducer;
export default accessorialReviewTerminalPerformanceReducer;